import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=2584f5a0&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Icon/index.vue').default,UiBadge: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Badge.vue').default})
